
document.addEventListener('DOMContentLoaded', () => {
  initTabs(document, {
    tabsRootSelector: '.product-info-tabs',
    buttonSelector: '[data-tab-button]',
    panelSelector: '[data-tab-panel]',
    activeClass: 'is-active',
    panelHideDelay: 180,
  });
});

function initTabs(root, options) {
  const settings = {
    tabsRootSelector: '.product-info-tabs',
    buttonSelector: '[data-tab-button]',
    panelSelector: '[data-tab-panel]',
    activeClass: 'is-active',
    panelHideDelay: 180,
    ...options,
  };

  function setActiveTab(tabsRoot, target) {
    if (!tabsRoot || !target) return;

    const buttons = tabsRoot.querySelectorAll(settings.buttonSelector);
    const panels = tabsRoot.querySelectorAll(settings.panelSelector);

    buttons.forEach((button) => {
      const isActive = button.dataset.tabButton === target;
      button.classList.toggle(settings.activeClass, isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.tabPanel === target;

      if (isActive) {
        panel.hidden = false;
        requestAnimationFrame(() => {
          panel.classList.add(settings.activeClass);
        });
        return;
      }

      panel.classList.remove(settings.activeClass);
      setTimeout(() => {
        panel.hidden = true;
      }, settings.panelHideDelay);
    });
  }

  function activateFromButton(button, shouldFocus) {
    if (!button) return;

    const tabsRoot = button.closest(settings.tabsRootSelector);
    const target = button.dataset.tabButton;
    if (!tabsRoot || !target) return;

    setActiveTab(tabsRoot, target);
    if (shouldFocus) button.focus();
  }

  root.querySelectorAll(settings.tabsRootSelector).forEach((tabsRoot) => {
    const buttons = tabsRoot.querySelectorAll(settings.buttonSelector);
    if (buttons.length === 0) return;

    const activeButton = Array.from(buttons).find((button) => button.classList.contains(settings.activeClass));
    activateFromButton(activeButton || buttons[0], false);
  });

  root.addEventListener('click', (event) => {
    const button = event.target.closest(settings.buttonSelector);
    if (!button) return;
    activateFromButton(button, false);
  });

  root.addEventListener('keydown', (event) => {
    const button = event.target.closest(settings.buttonSelector);
    if (!button) return;

    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const tabsRoot = button.closest(settings.tabsRootSelector);
    if (!tabsRoot) return;

    const buttons = Array.from(tabsRoot.querySelectorAll(settings.buttonSelector));
    const currentIndex = buttons.indexOf(button);
    if (currentIndex < 0) return;

    event.preventDefault();

    let nextIndex = currentIndex;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = buttons.length - 1;

    activateFromButton(buttons[nextIndex], true);
  });
}